export default "__VITE_ASSET__0171da19__"